import React from 'react';
import { getDomainConfig, CONTACT_INFO } from '../config';
import './LegalPage.css';

function ShippingPolicyPage() {
  const config = getDomainConfig();
  const hostname = window.location.hostname.replace('www.', '');
  const displayEmail = `info@${hostname}`;

  return (
    <div className="legal-page">
      <h1>Shipping Policy</h1>
      <p className="last-updated">Last Updated: February 2026</p>

      <div className="legal-content">
        <section>
          <h2>1. Overview</h2>
          <p>
            {config.name}, operated by {CONTACT_INFO.businessName}, works with a network of suppliers
            and manufacturers across North America to deliver products to your location. Shipping
            methods, costs, and delivery times may vary depending on the product, supplier, and
            destination.
          </p>
        </section>

        <section>
          <h2>2. Shipping Methods</h2>
          <p>We offer the following shipping options through our supplier network:</p>
          <ul>
            <li><strong>Standard Shipping:</strong> 5-10 business days (most products)</li>
            <li><strong>Expedited Shipping:</strong> 2-5 business days (available for select items)</li>
            <li><strong>Freight Shipping:</strong> For large or heavy items, freight shipping is arranged
            with delivery times varying by destination</li>
          </ul>
          <p>
            Specific shipping options and costs will be confirmed when your quote is processed.
            Delivery times are estimates and may vary based on product availability and your location.
          </p>
        </section>

        <section>
          <h2>3. Shipping Costs</h2>
          <p>
            Shipping costs are calculated based on the product weight, dimensions, shipping method,
            and destination. Exact shipping costs will be provided as part of your quote. For bulk
            orders, we may be able to offer discounted or complimentary shipping.
          </p>
        </section>

        <section>
          <h2>4. Order Processing</h2>
          <p>
            Orders are typically processed within 1-3 business days after confirmation. Once your
            order has shipped, you will receive a confirmation email with tracking information when
            available.
          </p>
          <p>
            Please note that processing times may be longer for custom-made, specialty, or
            made-to-order products.
          </p>
        </section>

        <section>
          <h2>5. Shipping Destinations</h2>
          <p>
            We primarily ship within the United States and Canada. International shipping may be
            available for certain products. Please contact us for international shipping inquiries
            and to receive a shipping quote for your location.
          </p>
        </section>

        <section>
          <h2>6. Order Tracking</h2>
          <p>
            Once your order ships, you will receive tracking information via email. If you have not
            received tracking information within 5 business days of placing your order, please
            contact our support team.
          </p>
        </section>

        <section>
          <h2>7. Damaged or Lost Shipments</h2>
          <p>
            If your shipment arrives damaged or is lost in transit, please contact us immediately.
            We will work with the shipping carrier and supplier to resolve the issue, which may
            include filing a claim and arranging for a replacement shipment.
          </p>
          <p>
            Please inspect all packages upon delivery and note any visible damage on the delivery
            receipt. Take photos of any damage for documentation purposes.
          </p>
        </section>

        <section>
          <h2>8. Contact Us</h2>
          <p>
            For shipping questions or to request a shipping quote, please contact us:
          </p>
          <p><strong>{CONTACT_INFO.businessName}</strong></p>
          <p>Email: {displayEmail}</p>
          <p>Phone: {CONTACT_INFO.phone}</p>
          <p>Address: {CONTACT_INFO.address}, {CONTACT_INFO.city}, {CONTACT_INFO.state} {CONTACT_INFO.zip}</p>
        </section>
      </div>
    </div>
  );
}

export default ShippingPolicyPage;
